<template>
  <header id="header">
    <v-app-bar color="primary" dark app>
      <v-toolbar-title class="white--text">Kabu</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu offset-y>
        <template v-slot:activator="{on}">
        <v-btn v-on="on" text>Menu</v-btn>
        </template>
        
        <v-list>
            <v-list-item href="/">
            <v-list-item-content>
                <v-list-item-title>TOP</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item to="/home/user_incentives">
            <v-list-item-content>
                <v-list-item-title>優待取得状況</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item to="/home/crosses">
            <v-list-item-content>
                <v-list-item-title>一般信用残</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item href="/ipos">
            <v-list-item-content>
                <v-list-item-title>IPO</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item href="https://www.freebbs.biz/xbrl/index.html">
            <v-list-item-content>
                <v-list-item-title>財務分析</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
        </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </header>
</template>

<script>
import axios from 'axios';
  export default {
    name: 'Header',
  }
</script>